import "./App.css";
import { BrowserRouter, useLocation, useNavigate } from "react-router-dom";
import RouteComponent from "./Router/RouteComponent";
import ScrollToTop from "./scrolltotop";
import Header from "./Components/Header";
import Sidebar from "./Components/Sidebar";
import { useEffect, useState } from "react";
import { verifyToken } from "./actions/auth";
import { useDispatch } from "react-redux";
import { RoutesPaths } from "./Router/constant";
import { Toaster } from "react-hot-toast";
import "quill/dist/quill.snow.css";
import { connectSocket } from "./Pages/socket/socket";

function AppLayout() {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const [showAside, setShowAside] = useState(false);

  const authPaths = [RoutesPaths.LOGIN];
  const hideLayout = authPaths.includes(location.pathname);

  useEffect(() => {
    if (!authPaths.includes(location.pathname)) {
      verifyUserToken();
    }
  }, []);

  useEffect(() => {
    setShowAside(false);
  }, [location.pathname]);
  const verifyUserToken = async () => {
    try {
      const response = await dispatch(verifyToken());
      if (!response?.data?.status) {
        navigate(RoutesPaths.LOGIN, { replace: true });
        connectSocket();
      }
    } catch (error) {
      navigate(RoutesPaths.LOGIN, { replace: true });
    }
  };

  return (
    <>
      {!hideLayout && <Header onToggleAside={() => setShowAside(!showAside)} />}

      {!hideLayout && <Sidebar showAside={showAside} />}

      <div className={!hideLayout ? "mainContentSection" : ""}>
        <RouteComponent />
      </div>
    </>
  );
}

function App() {
  return (
    <BrowserRouter>
      <Toaster />
      <ScrollToTop />
      <AppLayout />
    </BrowserRouter>
  );
}

export default App;
